export const OrientationOptions = {
	horizontal: 'horizontal',
	vertical: 'vertical',
} as const;

export type Orientation = typeof OrientationOptions[keyof typeof OrientationOptions];
